import { DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  HStack,
  Stack,
} from "@chakra-ui/react";
import React, { useRef, useState } from "react";

export function useFormsetDrawer({
  values = [],
  formIndex,
  onClose,
  onRemove,
  onSaveEdit,
  saveButtonText,
  isLoading,
  defaultValue = {},
  validateForm,
  isModal = true,
  isMobile,
}: {
  values: Array<any>;
  formIndex: any;
  onClose: any;
  onRemove: any;
  onSaveEdit: (values: any) => Promise<any>;
  saveButtonText: string;
  validateForm: (state: any) => boolean;
  defaultValue: any;
  isLoading?: boolean;
  isModal?: boolean;
  isMobile?: boolean;
}) {
  const formikFormRef = useRef();
  let formVals = formIndex >= 0 ? values[formIndex] : defaultValue;
  const [value, setValue] = useState(formVals);
  // const isMobile = useMedia("(max-width: 420px)");
  React.useEffect(() => {
    // onSaveEdit(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleSave = () => {
    const form: any = formikFormRef.current;
    const values = form.state?.values || form.values; // formik version change
    let isValidated = validateForm(values);
    if (form) {
      form.submitForm();
      if (isValidated) {
        onSaveEdit(values).then(() => {
          onClose();
        });
      }
    }
  };

  const handleRemoveClick = () => {
    onRemove();
    onClose();
  };

  const handleCloseClick = () => {
    onClose();
  };
  const controlActions = (
    <ControlAction
      {...{
        isLoading,
        formIndex,
        handleCloseClick,
        handleSave,
        saveButtonText,
        handleRemoveClick,
        isModal,
        isMobile,
      }}
    />
  );
  return {
    controlActions,
    formikFormRef,
    formVals,
    onSubmit: (data: any) => setValue(data),
  };
}

type ControlActionProps = {
  isMobile?: boolean;
  formIndex: number;
  handleRemoveClick: () => void;
  handleCloseClick: () => void;
  handleSave: () => void;
  saveButtonText?: string;
  isLoading?: boolean;
  isModal?: boolean;
};
const ControlAction = ({
  isMobile,
  formIndex,
  handleRemoveClick,
  handleCloseClick,
  handleSave,
  isLoading,
  saveButtonText = "",
  isModal = true,
}: ControlActionProps) => {
  const spread = isModal
    ? {}
    : {
        display: { base: "flex", md: "flex" },
      };
  const controlActions = (
    <Flex align="center" justify="space-between" {...spread}>
      {formIndex >= 0 ? (
        <Button
          leftIcon={<DeleteIcon />}
          aria-label="Delete"
          variant="link"
          colorScheme="red"
          onClick={handleRemoveClick}
        >
          Remove
        </Button>
      ) : (
        <Box />
      )}
      <ButtonGroup spacing={[2, 5, 5, 3]}>
        <Button variant="outline" colorScheme="red" onClick={handleCloseClick}>
          Cancel
        </Button>
        <Button
          type="submit"
          isLoading={isLoading}
          onClick={handleSave}
          colorScheme="blue"
        >
          {saveButtonText}
        </Button>
      </ButtonGroup>
    </Flex>
  );
  return (
    <>
      {controlActions}
      {isMobile ? (
        <Stack
          pt={6}
          spacing={5}
          width="full"
          display={{ base: "block", md: "none" }}
        >
          <Button
            type="submit"
            isFullWidth
            size="lg"
            isLoading={isLoading}
            loadingText="Saving"
            onClick={handleSave}
            colorScheme="blue"
          >
            {saveButtonText}
          </Button>

          <HStack width="full" spacing={3}>
            {formIndex >= 0 ? (
              <Button
                isFullWidth
                leftIcon={<DeleteIcon />}
                aria-label="Delete"
                variant="outline"
                colorScheme="red"
                onClick={handleRemoveClick}
              >
                Remove
              </Button>
            ) : null}
            <Button
              isFullWidth
              variant={"outline"}
              colorScheme="gray"
              onClick={handleCloseClick}
            >
              Cancel
            </Button>
          </HStack>
        </Stack>
      ) : null}
    </>
  );
};
